import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-insurance-companies",
  templateUrl: "./insurance-companies.component.html",
})
export class InsuranceCompaniesComponent implements OnInit {
  rowsData = [
    { title: "Insurance Company", sorting: true, name: "name" },
    { title: "Country" },
    { title: "CountryCode" },
  ];

  columnsData = [];
  columnsRes = [];
  p = 1;
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSize = 10;
  maxSizeItem = 10;
  firstNameControl = new FormControl();
  formCtrlSub: Subscription;
  searchPatient = "";
  sortColumn = "name";
  orderColumn = "asc";
  searchText = "";
  alphaVal = "all";
  routerName = "";
  maxSizeItemValue: any;
  address: any = "";

  countryData = [];
  countryidadmin: any = "";
  country: any = "";
  selectedCountry: any = "";

  constructor(
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private router: Router
  ) {}

  ngOnInit() {
    this.getAllInsuranceListAdmin("");
    this.getAllCountry();

    this.supportService.gridSortingHeader.subscribe((res) => {
      if (res && res["length"] !== 0 && res["routerName"] === this.routerName) {
        this.sortColumn = res["name"];
        this.orderColumn = res["order"];
        const event = {
          page: 1,
        };
        this.currentPage = 1;
        this.getAllInsuranceListAdmin(event);
      }
    });
    this.checkUrl();
  }

  getAllCountry() {
    this.appService.getCountry().subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.countryData = res["entity"];
      } else {
        this.countryData = [];
      }
    });
  }

  onChange(event) {
    sessionStorage.setItem("countryidadmin", this.selectedCountry.id);
    this.countryidadmin = sessionStorage.getItem("countryidadmin");
    this.getAllInsuranceListAdmin("");
  }

  checkUrl() {
    const path = this.location.path().split("/");
    if (path.length === 3) {
      this.routerName = path[2];
    }
  }

  onBlurSearchMethod() {
    this.searchPatient = this.searchText;
    this.currentPage = 1;
    this.getAllInsuranceListAdmin("");
  }

  refreshPatient() {
    this.searchText = "";
    this.searchPatient = "";
    this.selectedCountry = "";
    this.countryidadmin = "";
    this.getAllInsuranceListAdmin("");
  }

  alphaSearch(val) {
    if (val !== "all") {
      this.searchPatient = val;
    } else {
      this.searchPatient = "";
    }
    this.alphaVal = val;
    this.searchText = "";
    this.getAllInsuranceListAdmin("");
  }

  getAllInsuranceListAdmin(event) {
    let data;
    if (event) {
      data = {
        pageNumber: event.page,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        countryid: this.countryidadmin,
      };
    } else {
      data = {
        pageNumber: 1,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        countryid: this.countryidadmin,
      };
    }

    this.appService.getAllInsuranceListAdminWithFilter(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsData = [];
            this.columnsRes = res["entity"];
            this.columnsRes.forEach((obj) => {
              this.columnsData = this.columnsData.concat({
                param1: obj.name ? obj.name : "-",
                param2:
                  obj.countryId === 101
                    ? "India"
                    : obj.countryId === 231
                    ? "United States"
                    : "-",
                param3:
                  obj.countryId === 101
                    ? "IN"
                    : obj.countryId === 231
                    ? "US"
                    : "-",
              });
            });
            this.totalItems = res["count"];
          }
        } else {
          this.columnsData = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  pageChanged(event: any): void {
    this.page = event.page;
    this.getAllInsuranceListAdmin(event);
  }

  navigateToDashboard() {
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "dashboard",
    ]);
  }
}
